<template>
  <div class="pt-1 max-h-[50dvh] w-[50dvw]">
    <div class="text-start mb-1">
      <el-radio-group v-model="field.is_global_variable">
        <el-radio-button :label="false">Custom Field</el-radio-button>
        <el-radio-button :label="true">Global Variable</el-radio-button>
      </el-radio-group>
    </div>
    <el-form label-position="right" v-if="!field.is_global_variable">
      <div class="w-full">
        <title-and-description :field="field" />
      </div>
      <div class="w-full">
        <placeholder :field="field" />
      </div>
      <el-col>
        <!-- <is-field-required :field="field" class="field-required"/> -->
        <span class="!text-brand-500 py-3">
          *After confirming that you are not a robot, you will be granted access to this field for
          further verification*
        </span>
      </el-col>
    </el-form>

    <el-form label-position="right" v-if="field.is_global_variable" class="pt-1">
      <el-form-item>
        <div class="flex flex-col gap-2 w-full">
          <label
            for=""
            class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
          >
            Global Variable
          </label>
          <el-select v-model="field.global_variable_id" @change="setGlobalVariable">
            <el-option
              v-for="(globalVariable, index) of allGlobalVariables"
              :key="index"
              :label="globalVariable.label"
              filterable
              :value="globalVariable._id"
            ></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-row class="pt-1">
        <placeholder :field="field" />
        <!-- <el-col :span="12">
            <field-filled-by :field="field" />
          </el-col>
        </el-row>
        <is-field-required :field="field" class="field-required"/> -->
      </el-row>
      <div class="">
        <span style="font-style: italic; color: #3366cc" class="w-full py-3">
          *After confirming you are not a robot, you will be granted access to this field for
          further verification*
        </span>
      </div>
    </el-form>
  </div>
</template>

<script>
  //import { mapGetters } from "vuex";
  export default {
    components: {
      TitleAndDescription: () => import('./TitleAndDescription'),
      //IsFieldRequired: () => import("./IsFieldRequired"),
      //FieldFilledBy: () => import("./FieldFilledBy"),
      Placeholder: () => import('./Placeholder'),
      //FieldAttributes: () => import("./FieldAttributes"),
    },
    props: ['field'],
  };
</script>
<style scoped>
  .info-text {
    font-style: italic;
    color: #3366cc;
  }
</style>
